<template><article><h1>Common usage</h1>
<h3 id="single-slider"><a class="header-anchor" href="#single-slider" aria-hidden="true">#</a> Single slider</h3>
<p><example :value="example1"></example></p>
<h3 id="multiple-sliders"><a class="header-anchor" href="#multiple-sliders" aria-hidden="true">#</a> Multiple sliders</h3>
<p><example :value="example2"></example></p>
<h3 id="set-the-range-of-values"><a class="header-anchor" href="#set-the-range-of-values" aria-hidden="true">#</a> Set the range of values</h3>
<p><example :value="example3"></example></p>
<h3 id="set-the-slider-direction"><a class="header-anchor" href="#set-the-slider-direction" aria-hidden="true">#</a> Set the slider direction</h3>
<p><example :value="example4"></example></p>
<div class="tip custom-block"><p class="custom-block-title">TIP</p>
<ul>
<li><code v-pre>ltr</code> stands for <code v-pre>left to right</code>, the horizontal slider from left to right. <code v-pre>rtl/btt/ttb</code> is the same</li>
<li>When the value of <code v-pre>direction</code> is <code v-pre>btt</code> or <code v-pre>ttb</code>, you need to set the component height</li>
</ul>
</div>
<h3 id="lazy"><a class="header-anchor" href="#lazy" aria-hidden="true">#</a> Lazy</h3>
<p>The value will only be updated when the drag is over</p>
<p><example :value="example5"></example></p>
<div class="tip custom-block"><p class="custom-block-title">TIP</p>
<p>If you need to use the internal value of the component when dragging, you can listen to the <code v-pre>dragging</code> event or use the <code v-pre>default slot</code>.</p>
</div>
<h3 id="disabled-slider"><a class="header-anchor" href="#disabled-slider" aria-hidden="true">#</a> Disabled slider</h3>
<p>You can disable the entire component with <code v-pre>disabled</code> or disable the slider separately with <code v-pre>dot-options</code></p>
<p><example :value="example6"></example></p>
<div class="warning custom-block"><p class="custom-block-title">WARNING</p>
<p>When disabling a single slider, use <code v-pre>order = false</code> or <code v-pre>enableCross = true</code>.</p>
</div>
<h3 id="adsorb"><a class="header-anchor" href="#adsorb" aria-hidden="true">#</a> Adsorb</h3>
<p>When <code v-pre>adsorb</code> is set to <code v-pre>true</code>, the slider automatically adsorb to the nearest value.</p>
<p><example :value="example7"></example></p>
<h3 id="contained"><a class="header-anchor" href="#contained" aria-hidden="true">#</a> Contained</h3>
<p>By default, the center of the <code v-pre>dot</code> is used to align the edge.</p>
<p>When <code v-pre>contained</code> is set to <code v-pre>true</code>, the edge of the <code v-pre>dot</code> is used to align.</p>
<p><example :value="example8"></example></p>
<h3 id="dragonclick"><a class="header-anchor" href="#dragonclick" aria-hidden="true">#</a> DragOnClick</h3>
<p>When <code v-pre>drag-on-click</code> is set to <code v-pre>true</code>, can drag the slider directly when pressing the process.</p>
<p><example :value="example9"></example></p>
</article></template>

<script>
  import examples from '@/examples/simple.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>